export default {"src":"/_next/static/media/close-gray.06ae5729.svg","height":16,"width":16};